import {
  EllipsisWithTooltip,
  ExternalLink,
  Typography,
} from '@cast/design-system';

import { makeSelectionTemplatesLink } from 'features/cluster/autoscaler/utils';

import { EdgeConfigurationListItem } from './types';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type LinkedTemplatesCellProps = {
  config: EdgeConfigurationListItem;
};

export const LinkedTemplatesCell = ({ config }: LinkedTemplatesCellProps) => {
  const { cluster } = useCluster();

  const linkedTemplates = config.linkedTemplates || [];

  if (linkedTemplates.length === 0) {
    return <Typography variant="P12R">-</Typography>;
  }

  const templateNames = linkedTemplates
    .map((t) => t.template?.name)
    .filter(Boolean)
    .join(', ');

  const nodeTemplatesLink = makeSelectionTemplatesLink({
    clusterId: cluster.id,
  });

  return (
    <ExternalLink
      link={nodeTemplatesLink}
      noIcon
      sx={{ width: '100%' }}
      onClick={(e) => e.stopPropagation()}
    >
      <EllipsisWithTooltip TypographyProps={{ variant: 'P12R' }}>
        {templateNames}
      </EllipsisWithTooltip>
    </ExternalLink>
  );
};
